import script from "./Dropzone.vue?vue&type=script&setup=true&lang=js"
export * from "./Dropzone.vue?vue&type=script&setup=true&lang=js"

import "./Dropzone.vue?vue&type=style&index=0&id=30e1e446&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30e1e446"]])

export default __exports__